<div *ngIf="total > 0" class="location-warehouse-app-picklist-total">
  <button class="lum-button lum-button--tertiary" [matMenuTriggerFor]="menu">
    <i class="fa fa-exclamation-triangle text-danger"></i>
  </button>
  <mat-menu #menu="matMenu">
    <button
      *ngFor="let item of picklistItems; trackBy: trackById"
      mat-menu-item
      (click)="onPicklistClick($event)"
    >
      Picklist #{{ item.picklist_id }} - {{ item.available_quantity }}
    </button>
    <button mat-menu-item class="font-bold">Total: {{ total }}</button>
  </mat-menu>
</div>
